import Image from "next/image"
import { Anchor } from "../../app/components/anchor"

export default function PetTransportCoverage() {
  return (
    <section className="relative py-12 px-4 lg:px-16 bg-gray3 text-xl text-center">
      <Image
        className="hidden lg:block absolute left-10 top-10"
        src="/icons/dog-illustration.webp"
        alt="dog-illustration"
        width={72}
        height={72}
      />
      <Image
        className="hidden lg:block absolute right-10 top-10"
        src="/icons/cat-illustration.webp"
        alt="cat-illustration"
        width={72}
        height={72}
      />

      <h3 className="mb-6 font-montserrat font-medium text-3xl text-center">
        Our promise: safe and happy pets at every step
      </h3>
      <p>
        Your pets are so much more than four legs and a tail — they’re members
        of your family and best friends for life.
      </p>
      <p>
        We’re proud to be the nation’s top-rated and leading service for pet
        transportation. Our unique process matches you with a fleet of
        pre-screened drivers that you have the luxury to choose from.
      </p>
      <p>
        You’ll know exactly who’ll care for your beloved pet, whether it's a
        puppy, kitten or a full-grown cat or dog.
      </p>
      <section className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-x-4 xl:gap-x-20 gap-y-4 lg:gap-y-10">
        <figure className="flex text-left">
          <Image
            className="w-14 h-14 mr-5 object-contain"
            src="/icons/protection.svg"
            alt="protection"
            width={56}
            height={56}
          />
          <figcaption>
            <h3>$1k Pet Protection Coverage</h3>
            <p className="mr-4 text-base">
              Up to $1,000 pet protection guarantee
              <cite>
                <Anchor href="https://help.citizenshipper.com/hc/en-us/articles/4409492873101-CitizenShipper-Pet-Protection-Plan-Terms-and-Conditions">
                  1
                </Anchor>
              </cite>{" "}
              to give you peace of mind when booking.
            </p>
          </figcaption>
        </figure>
        <figure className="flex text-left">
          <Image
            className="w-14 h-14 mr-5 object-contain"
            src="/icons/vet.svg"
            alt="vet"
            width={56}
            height={56}
          />
          <figcaption>
            <h3>24/7 access to TeleVet Care</h3>
            <p className="mr-4 text-base">
              Offered through our partner Vetster for your peace of mind.
            </p>
          </figcaption>
        </figure>
        <figure className="flex text-left">
          <Image
            className="w-14 h-14 mr-5 object-contain"
            src="/icons/trust.svg"
            alt="trust"
            width={56}
            height={56}
          />
          <figcaption>
            <h3>Booking Assurance Guaranteed</h3>
            <p className="mr-4 text-base">
              From quote to delivery, so you can select and ship with confidence
              <cite>
                <Anchor href="https://help.citizenshipper.com/hc/en-us/articles/360041203251-CitizenShipper-Booking-Assurance-Guarantee">
                  2
                </Anchor>
              </cite>
              .
            </p>
          </figcaption>
        </figure>
        <figure className="flex text-left">
          <Image
            className="w-14 h-14 mr-5 object-contain"
            src="/icons/guarantee.svg"
            alt="guarantee"
            width={56}
            height={56}
          />
          <figcaption>
            <h3>$1k Pet Protection Coverage</h3>
            <p className="mr-4 text-base">
              Background checks
              <cite>
                <Anchor href="https://help.citizenshipper.com/hc/en-us/articles/203050235-Why-is-Background-Screening-so-Important-">
                  3
                </Anchor>
              </cite>
              , direct contact with drivers and thousands of customer reviews at
              your fingertips. Because your pet should only be in the best of
              hands.
            </p>
          </figcaption>
        </figure>
      </section>
    </section>
  )
}
